import { ITaskBlock } from 'shared/express-interface/blocks-core/ITaskBlock'
import { MCPTool, ToolMetaData } from 'Types/Tasks.types'
import EmptyContent from './EmptyContent/EmptyContent'
import styles from './AgenticAnnotationTaskUI.module.less'
import { ToolsContainer } from './ToolsContent/ToolsContainer'
import { JSONObject } from 'Types/Common.types'

export type AgenticAnnotationTaskUIProps = {
    blocks: ITaskBlock[]
    mcpTools: MCPTool[]
    onSelectTool: (toolName: string) => void
    toolDataFn: () => ToolMetaData[]
    onTestToolCall: (toolId: string) => void
    onReorderTools: (items: ToolMetaData[]) => void
    onDeleteTool: (toolId: string) => void
    onChange: (toolId: string, value: JSONObject) => void
    readOnly: () => boolean
    toolCallsLoadingIdsFn: () => string[]
}

export const AgenticAnnotationTaskUI = (props: AgenticAnnotationTaskUIProps) => {
    const toolData = props.toolDataFn()
    const toolCallsLoadingIds = props.toolCallsLoadingIdsFn()

    const isReadOnly = props.readOnly()

    return (
        <div className="summarize-root" data-testid="agentic-task-ui-wrapper">
            {props.blocks.map((block, index) => (
                <div key={block.type || index}>{block.getElement()?.element}</div>
            ))}

            <div className={styles['content-container']}>
                <p className={styles['content-title']}>Tool Trajectory</p>

                {toolData.length > 0 ? (
                    <ToolsContainer
                        toolData={toolData}
                        mcpTools={props.mcpTools}
                        onSelectTool={props.onSelectTool}
                        onReorderTools={props.onReorderTools}
                        onDeleteTool={props.onDeleteTool}
                        onChange={props.onChange}
                        onTestToolCall={props.onTestToolCall}
                        readOnly={isReadOnly}
                        toolCallsLoadingIds={toolCallsLoadingIds}
                    />
                ) : (
                    <EmptyContent mcpTools={props.mcpTools} onSelectTool={props.onSelectTool} />
                )}
            </div>
        </div>
    )
}
